import { PersonGroup } from "./base$PersonGroup";
import { FileDescriptor } from "./sys$FileDescriptor";
import { PersonExt } from "./base$PersonExt";
import { Retirement } from "./tsadv$Retirement";
import { Disability } from "./tsadv$Disability";
import { MilitaryForm } from "./tsadv$MilitaryForm";
import { CompetenceElement } from "./tsadv$CompetenceElement";
import { AssignmentExt } from "./base$AssignmentExt";
import { PersonContact } from "./tsadv$PersonContact";
import { PersonDocument } from "./tsadv$PersonDocument";
import { Assessment } from "./tsadv$Assessment";
import { PersonEducation } from "./tsadv$PersonEducation";
import { PersonExperience } from "./tsadv$PersonExperience";
import { PersonAttachment } from "./tsadv$PersonAttachment";
import { JobRequest } from "./tsadv$JobRequest";
import { SuccessionPlanning } from "./tsadv$SuccessionPlanning";
import { BusinessTrip } from "./tsadv$BusinessTrip";
import { Agreement } from "./tsadv$Agreement";
import { Dismissal } from "./tsadv$Dismissal";
import { Case } from "./tsadv$Case";
import { PersonReview } from "./tsadv$PersonReview";
import { Address } from "./tsadv$Address";
import { StudentGrant } from "./tsadv$StudentGrant";
import { ReLocation } from "./tsadv$ReLocation";
import { PersonExpectedSalary } from "./tsadv$PersonExpectedSalary";
import { Beneficiary } from "./tsadv$Beneficiary";
import { IndividualDevelopmentPlan } from "./tsadv$IndividualDevelopmentPlan";
import { Internship } from "./tsadv$Internship";
import { Enrollment } from "./tsadv$Enrollment";
import { Attestation } from "./tsadv$Attestation";
import { CandidateRequirement } from "./tsadv$CandidateRequirement";
import { DicCompany } from "./base_DicCompany";
import { Absence } from "./tsadv$Absence";
import { DicSocStatus } from "./tsadv_DicSocStatus";
import { DicDriverCategory } from "./tsadv_DicDriverCategory";
import { PersonMedalRequest } from "./tsadv_PersonMedalRequest";
export class PersonGroupExt extends PersonGroup {
  static NAME = "base$PersonGroupExt";
  image?: FileDescriptor | null;
  list?: PersonExt[] | null;
  retirement?: Retirement[] | null;
  disability?: Disability[] | null;
  militaryRank?: MilitaryForm[] | null;
  person?: PersonExt | null;
  relevantPerson?: PersonExt | null;
  competenceElements?: CompetenceElement[] | null;
  assignments?: AssignmentExt[] | null;
  personContacts?: PersonContact[] | null;
  personDocuments?: PersonDocument[] | null;
  assessments?: Assessment[] | null;
  mobilePhone?: string | null;
  smsCode?: string | null;
  personEducation?: PersonEducation[] | null;
  personExperience?: PersonExperience[] | null;
  personAttachment?: PersonAttachment[] | null;
  jobRequests?: JobRequest[] | null;
  successionPlanning?: SuccessionPlanning[] | null;
  businessTrip?: BusinessTrip[] | null;
  agreements?: Agreement[] | null;
  dismissals?: Dismissal[] | null;
  cases?: Case[] | null;
  reviews?: PersonReview[] | null;
  likeCount?: any | null;
  disLikeCount?: any | null;
  addresses?: Address[] | null;
  studentGrants?: StudentGrant[] | null;
  relocation?: ReLocation[] | null;
  expectedSalary?: PersonExpectedSalary[] | null;
  linkedinAccessToken?: string | null;
  linkedinProfileLink?: string | null;
  linkedinTokenExpiresInDate?: any | null;
  beneficiary?: Beneficiary[] | null;
  individualDevelopmentPlan?: IndividualDevelopmentPlan[] | null;
  internship?: Internship[] | null;
  enrollment?: Enrollment[] | null;
  attestation?: Attestation[] | null;
  candidateRequirement?: CandidateRequirement[] | null;
  company?: DicCompany | null;
  requestNumber?: string | null;
  absence?: Absence[] | null;
  socStatus?: DicSocStatus | null;
  driverCategory?: DicDriverCategory | null;
  personMedalRequests?: PersonMedalRequest[] | null;
  totalExperience?: any | null;
  personFioWithEmployeeNumber?: string | null;
  activeAssessment?: Assessment | null;
  currentAssignment?: AssignmentExt | null;
  currentAssignmentWithSuspendedAndTerminatedStatus?: AssignmentExt | null;
  currentAssignmentWithSuspendedStatus?: AssignmentExt | null;
  primaryAssignment?: AssignmentExt | null;
  fullName?: string | null;
  firstLastName?: string | null;
  fioWithEmployeeNumber?: string | null;
  personLatinFioWithEmployeeNumber?: string | null;
  personFirstLastNameLatin?: string | null;
}
export type PersonGroupExtViewName =
  | "_base"
  | "_local"
  | "_minimal"
  | "assignment.card.personGroup"
  | "person-group-ext-intern"
  | "personGroup-for-absenceRequest"
  | "personGroup-relevantPerson-fullNameCyrillic"
  | "personGroup-view"
  | "personGroup-with-position"
  | "personGroup.add.reserve"
  | "personGroup.browse"
  | "personGroup.candidate"
  | "personGroup.contacts"
  | "personGroup.currentAssignment"
  | "personGroup.for.absences"
  | "personGroup.linkedin"
  | "personGroup.listInfo"
  | "personGroup.master"
  | "personGroup.noAssignment"
  | "personGroup.person.info"
  | "personGroup.position.fullname"
  | "personGroup.scrum.competence"
  | "personGroup.search"
  | "personGroup.search.candidate"
  | "personGroup.with.positionGroup"
  | "personGroupBeneficiary"
  | "personGroupExt-Mic"
  | "personGroupExt-absenceEdit"
  | "personGroupExt-for-absenceRequest"
  | "personGroupExt-for-beneficary-request-edit"
  | "personGroupExt-for-integration-personBankDetails"
  | "personGroupExt-for-integration-rest"
  | "personGroupExt-for-load-attribute"
  | "personGroupExt-for-mobile-dms"
  | "personGroupExt-for-person-data"
  | "personGroupExt-for-search-candidate"
  | "personGroupExt-person-data"
  | "personGroupExt-person-data-fo-mobile"
  | "personGroupExt-registration"
  | "personGroupExt-view"
  | "personGroupExt-view-for-requisition-edit"
  | "personGroupExt-view-for-selvservice-requisition"
  | "personGroupExt-view_reg"
  | "personGroupExt.card"
  | "personGroupExt.edit"
  | "personGroupExt.for.enrollment.lookup"
  | "personGroupExt.for.requisition.edit"
  | "personGroupExt.for.requisition.optionDs"
  | "personGroupExt.lookup.for.attestation"
  | "personGroupExt.mobile"
  | "personGroupExt.rcg.feedback"
  | "personGroupExt.rcg.like"
  | "personGroupExt.responsibleEmployee"
  | "personGroupExt.substituteEmployee"
  | "personGroupExt.view.forPersonalData"
  | "personGroupExtFullName.view"
  | "personGroupExtInternship.edit"
  | "personGroupExtMultiLookup-browse"
  | "reservistPersonGroup";
export type PersonGroupExtView<
  V extends PersonGroupExtViewName
> = V extends "_base"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "person"
      | "list"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "fullName"
      | "competenceElements"
      | "company"
    >
  : V extends "_local"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
    >
  : V extends "_minimal"
  ? Pick<PersonGroupExt, "id" | "person" | "list" | "mobilePhone">
  : V extends "assignment.card.personGroup"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
      | "jobRequests"
      | "successionPlanning"
      | "businessTrip"
      | "dismissals"
    >
  : V extends "person-group-ext-intern"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
      | "person"
      | "fullName"
    >
  : V extends "personGroup-for-absenceRequest"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "company"
    >
  : V extends "personGroup-relevantPerson-fullNameCyrillic"
  ? Pick<
      PersonGroupExt,
      "id" | "person" | "list" | "mobilePhone" | "relevantPerson"
    >
  : V extends "personGroup-view"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "person"
    >
  : V extends "personGroup-with-position"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
      | "assignments"
      | "currentAssignment"
      | "company"
      | "person"
    >
  : V extends "personGroup.add.reserve"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
      | "assessments"
    >
  : V extends "personGroup.browse"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "company"
      | "list"
      | "assignments"
      | "personExperience"
    >
  : V extends "personGroup.candidate"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
      | "person"
      | "personEducation"
      | "personExperience"
      | "personAttachment"
      | "jobRequests"
      | "personContacts"
      | "agreements"
      | "beneficiary"
      | "individualDevelopmentPlan"
      | "internship"
      | "enrollment"
      | "attestation"
    >
  : V extends "personGroup.contacts"
  ? Pick<PersonGroupExt, "id" | "list" | "person" | "personContacts">
  : V extends "personGroup.currentAssignment"
  ? Pick<
      PersonGroupExt,
      "id" | "person" | "list" | "mobilePhone" | "currentAssignment"
    >
  : V extends "personGroup.currentAssignment"
  ? Pick<
      PersonGroupExt,
      "id" | "person" | "list" | "mobilePhone" | "currentAssignment"
    >
  : V extends "personGroup.for.absences"
  ? Pick<PersonGroupExt, "id" | "person"  | "mobilePhone" | "list">
  : V extends "personGroup.linkedin"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
      | "person"
    >
  : V extends "personGroup.listInfo"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
      | "assessments"
    >
  : V extends "personGroup.master"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
      | "person"
      | "personContacts"
      | "personDocuments"
      | "businessTrip"
      | "agreements"
      | "dismissals"
      | "cases"
      | "addresses"
      | "company"
    >
  : V extends "personGroup.noAssignment"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "image"
      | "list"
      | "assignments"
    >
  : V extends "personGroup.person.info"
  ? Pick<PersonGroupExt, "id" | "list" | "person">
  : V extends "personGroup.position.fullname"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
      | "assignments"
      | "currentAssignment"
      | "company"
      | "person"
      | "fullName"
    >
  : V extends "personGroup.scrum.competence"
  ? Pick<PersonGroupExt, "id" | "list" | "person">
  : V extends "personGroup.search"
  ? Pick<PersonGroupExt, "id" | "person" | "list">
  : V extends "personGroup.search.candidate"
  ? Pick<PersonGroupExt, "id" | "list" | "person">
  : V extends "personGroup.with.positionGroup"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "assignments"
    >
  : V extends "personGroupBeneficiary"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
      | "person"
      | "personEducation"
      | "personExperience"
      | "personAttachment"
      | "jobRequests"
      | "personContacts"
      | "agreements"
      | "beneficiary"
      | "individualDevelopmentPlan"
      | "internship"
      | "enrollment"
      | "attestation"
      | "personDocuments"
    >
  : V extends "personGroupExt-Mic"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
      | "assignments"
    >
  : V extends "personGroupExt-absenceEdit"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
    >
  : V extends "personGroupExt-for-absenceRequest"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "company"
    >
  : V extends "personGroupExt-for-beneficary-request-edit"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
      | "assignments"
      | "personExperience"
    >
  : V extends "personGroupExt-for-integration-personBankDetails"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
      | "company"
      | "assignments"
    >
  : V extends "personGroupExt-for-load-attribute"
  ? Pick<PersonGroupExt, "id" | "person" | "list">
  : V extends "personGroupExt-for-person-data"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
      | "company"
      | "assignments"
    >
  : V extends "personGroupExt-for-load-attribute"
  ? Pick<PersonGroupExt, "id" | "person" | "mobilePhone" | "list">
  : V extends "personGroupExt-for-mobile-dms"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "list"
      | "mobilePhone"
      | "person"
      | "personDocuments"
      | "addresses"
      | "company"
    >
  : V extends "personGroupExt-for-person-data"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
      | "assignments"
      | "personExperience"
    >
  : V extends "personGroupExt-for-search-candidate"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
      | "person"
      | "assignments"
      | "addresses"
      | "totalExperience"
      | "fullName"
      | "personExperience"
      | "currentAssignment"
      | "personContacts"
    >
  : V extends "personGroupExt-person-data"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
      | "person"
      | "assignments"
      | "personExperience"
    >
  : V extends "personGroupExt-person-data-fo-mobile"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
      | "person"
      | "assignments"
      | "personExperience"
    >
  : V extends "personGroupExt-registration"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "person"
      | "list"
      | "mobilePhone"
      | "smsCode"
      | "relevantPerson"
    >
  : V extends "personGroupExt-view"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "personDocuments"
      | "assignments"
      | "list"
      | "addresses"
    >
  : V extends "personGroupExt-view-for-requisition-edit"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "currentAssignment"
      | "personFioWithEmployeeNumber"
      | "list"
      | "assignments"
    >
  : V extends "personGroupExt-view-for-selvservice-requisition"
  ? Pick<PersonGroupExt, "id" | "person" | "list" | "mobilePhone" | "fullName">
  : V extends "personGroupExt-view_reg"
  ? Pick<PersonGroupExt, "id" | "person" | "list" | "mobilePhone" | "company">
  : V extends "personGroupExt.card"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "person"
      | "list"
      | "retirement"
      | "disability"
      | "militaryRank"
      | "competenceElements"
      | "personContacts"
      | "personDocuments"
      | "assessments"
      | "personEducation"
      | "personExperience"
      | "jobRequests"
      | "successionPlanning"
      | "businessTrip"
      | "agreements"
      | "dismissals"
      | "cases"
      | "addresses"
      | "relocation"
      | "beneficiary"
    >
  : V extends "personGroupExt.edit"
  ? Pick<PersonGroupExt, "id" | "person" | "list" | "mobilePhone">
  : V extends "personGroupExt.for.enrollment.lookup"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "person"
      | "list"
      | "mobilePhone"
      | "fullName"
      | "assignments"
      | "currentAssignment"
    >
  : V extends "personGroupExt.for.requisition.edit"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
      | "fullName"
    >
  : V extends "personGroupExt.for.requisition.optionDs"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "assignments"
      | "currentAssignment"
    >
  : V extends "personGroupExt.lookup.for.attestation"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
      | "person"
      | "fullName"
      | "assignments"
      | "currentAssignment"
    >
  : V extends "personGroupExt.mobile"
  ? Pick<PersonGroupExt, "id" | "list" | "assignments" | "person">
  : V extends "personGroupExt.rcg.feedback"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
    >
  : V extends "personGroupExt.rcg.like"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
    >
  : V extends "personGroupExt.responsibleEmployee"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
      | "fullName"
    >
  : V extends "personGroupExt.substituteEmployee"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
      | "personFioWithEmployeeNumber"
      | "fullName"
    >
  : V extends "personGroupExt.view.forPersonalData"
  ? Pick<PersonGroupExt, "id" | "list" | "person">
  : V extends "personGroupExtFullName.view"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
    >
  : V extends "personGroupExtInternship.edit"
  ? Pick<
      PersonGroupExt,
      | "id"
      | "mobilePhone"
      | "smsCode"
      | "linkedinAccessToken"
      | "linkedinProfileLink"
      | "linkedinTokenExpiresInDate"
      | "requestNumber"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "list"
      | "person"
      | "personContacts"
      | "addresses"
      | "personFioWithEmployeeNumber"
      | "fullName"
      | "assignments"
    >
  : V extends "personGroupExtMultiLookup-browse"
  ? Pick<
      PersonGroupExt,
      "id" | "person" | "list" | "mobilePhone" | "assignments"
    >
  : V extends "reservistPersonGroup"
  ? Pick<PersonGroupExt, "id" | "personFioWithEmployeeNumber" | "fullName">
  : never;
